// extracted by mini-css-extract-plugin
module.exports =  {"unit":"var(--ring-unit)","wrapper":"Avatar__wrapper--ie","avatar":"Avatar__avatar--VU","withOutline":"Avatar__withOutline--Kc","my":"Avatar__my--SO"};